import React from 'react';

interface Props {
    search: any,
    setSearch: any
}

export default function Search({search, setSearch}: Props) {
    return (
        <div className='search-container'>
            <input className="search-input" placeholder='Haku' onChange={(e) => setSearch(e.target.value)} value={search} />
            <button className="secondary inline" onClick={() => setSearch('')}>Tyhjää</button>
        </div>
    );
}